import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/shadcn/dialog';
import { Button } from '@/shared/ui/shadcn/button';
import aiGlassSparkle from '@/shared/assets/animations/ai-glass-sparkle.gif';

export interface RequestsCompletionDialogProps {
  open: boolean;
  onOpenChange(open: boolean): void;
  onGoToNextPatient(): void;
  onStay(): void;
  patientName: string;
  nextPatientName: string | null | undefined;
  isSuggesting?: boolean;
}

export function RequestsCompletionDialog({
  open,
  onOpenChange,
  onGoToNextPatient,
  onStay,
  patientName,
  nextPatientName,
  isSuggesting = false,
}: RequestsCompletionDialogProps) {
  const descriptionId = 'requests-completion-dialog-description';
  const titleId = 'requests-completion-dialog-title';

  const handleStay = () => {
    onStay();
    onOpenChange(false);
  };

  const handleGoToNextPatient = () => {
    if (nextPatientName === null || isSuggesting) {
      return;
    }
    onGoToNextPatient();
  };

  const description =
    nextPatientName === null
      ? "You're all caught up! No other patients need attention right now."
      : nextPatientName === undefined
        ? 'Ready to help another patient next?'
        : `Ready to help ${nextPatientName} next?`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        aria-describedby={descriptionId}
        aria-labelledby={titleId}
        overlayClassName="bg-black/40 backdrop-blur-sm"
        className="rounded-xl bg-background/80 backdrop-blur-md supports-[backdrop-filter]:bg-background/70"
      >
        <DialogHeader className="flex flex-col items-center text-center">
          <img
            src={aiGlassSparkle}
            alt="Celebration sparkle"
            className="h-40 w-40 object-contain"
          />
          <DialogTitle id={titleId}>Great work! {patientName} is all set</DialogTitle>
          <DialogDescription id={descriptionId}>{description}</DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex justify-center sm:justify-center">
          <Button type="button" variant="secondary" onClick={handleStay}>
            Stay here
          </Button>
          <Button
            type="button"
            onClick={handleGoToNextPatient}
            disabled={nextPatientName === null || isSuggesting}
          >
            {isSuggesting ? 'Finding…' : 'Keep the momentum going'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
